export default __webpack_public_path__ + "static/media/MarsFarmLogo.eeadcf5b.png";